import React, { useEffect, useRef, useState } from "react";
import "./ShortTermGoals.css";
import ReactDOM from "react-dom";
import CreateShortTermGoals from "Components/ReusableComponents/createshorttermgaols";
import DASHBOARD_API from "api/dashboard";
import { Card, message, Modal } from "antd";
import useCustomizeDash from "hooks/useCustomizeDash";
import HELPERS from "utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { deleteShortTermGoalsAsync, selectShortTermGoals, selectTimeline, setShortTermGoalsAsync, setTimelineAsync } from "slices/dashboardSlice";
import moment from "moment";
import { PlusOutlined } from "@ant-design/icons";
import Sortable from "sortablejs";
import { adjustPhaseDatesAfterSubtaskDeletion, adjustPhaseDatesAfterSubtaskEdit, getTextWidth, truncateToWidth, wrapTextToWidth } from "utils/shortTermGoals";


const userId = HELPERS.getUserId();

// Decide how to draw the connecting line from one task to the next
function getLineStyle(status) {
  switch (status) {
    case "completed":
      return "4px solid #199094"; // solid blue
    case "in-progress":
      return "3px dashed #66B5B8"; // dashed blue
    case "upcoming":
      return "3px dashed #66B5B8";
    default:
      return "3px dashed #66B5B8"; // pending or fallback
  }
}

function getGoalStatus(startDate, endDate){
  const today = moment()
  if (today.isBefore(startDate, 'day')) {
    return "upcoming";
  } else if (today.isAfter(endDate, 'day')) {
    // console.log('sss getGoalStatus', today, startDate, endDate)
    return "completed";
  } else {
    return "in-progress";
  }
}

export default function ShortTermGoals({setLeftSections, setRightSections, compID, left, tmpState, setTmpState}) {

  const shortTermGoals = useSelector(selectShortTermGoals);
  const timelineData = useSelector(selectTimeline);
  const [blankSTG, setBlankSTG] = useState(true);

  // const [goals, setGoals] = useState(DUMMY_DATA);
  // Flatten all sub-tasks into a single array so we can render them in a row,
  // keeping track of which goal they belong to.
  const flattenedTasks = [];
  shortTermGoals.filter(goal => goal?.subTasks?.length).forEach((goal, gIndex) => {
    console.log('sss goal', goal, goal.subTasks, shortTermGoals)
    goal.subTasks.forEach((task, tIndex) => {
      flattenedTasks.push({
        goalTitle: goal.step,
        goal: task.goal,
        goalIndex: gIndex,
        subTaskIndex: tIndex,
        stepId: goal.id,
        ...task,
        status: getGoalStatus(moment(task.startdate), moment(task.enddate)),
      });
    });
  });

  flattenedTasks.sort((a, b) => new Date(a.startdate) - new Date(b.startdate));
  
  // Fixed horizontal space for each sub-task.
  const SUBTASK_WIDTH = 180;
  
  let seen = new Set();
  const result = [];

  flattenedTasks.forEach((task, index) => {
    const key = `${task.goalTitle}`;
  
    // If it's not seen in the current sequence, process it
    if (!seen.has(key)) {
      const count = flattenedTasks
        .slice(index)
        .findIndex(t => t.goalTitle !== task.goalTitle);
  
      const actualCount = count === -1 
        ? flattenedTasks.length - index 
        : count;
  
      result.push({
        goalTitle: task.goalTitle,
        stepId: task.stepId,
        count: actualCount,
        ...task
      });
  
      seen.add(key);
    }
  
    // If next item breaks the sequence, reset `seen`
    const nextTask = flattenedTasks[index + 1];
    if (
      nextTask &&
      (nextTask.goalTitle !== task.goalTitle)
    ) {
      seen = new Set();
    }
  });

  console.log('sss flattenedTasks', flattenedTasks, result)

  useEffect(() => {

    if( flattenedTasks === null || flattenedTasks === undefined || flattenedTasks.length === 0 ){
      setBlankSTG(true)
    }
    else{
      setBlankSTG(false)
    }
  }, [flattenedTasks])
  

  // For each goal, find the first and last sub-task indexes.
  const goalBounds = flattenedTasks.map((goal, gIndex) => {
    // console.log('sss goalBounds', goal);
    const firstIndex = flattenedTasks.findIndex((t) => t.goalIndex === gIndex);
    const lastIndex = flattenedTasks.length - 1 - [...flattenedTasks].reverse().findIndex((t) => t.goalIndex === gIndex);
    return { gIndex, firstIndex, lastIndex };
  });
  const stgInnerHeaderRef = useRef(null); // Reference to the scrollable container
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [toggling, setToggling] = useState(false);
  const [editForm, setEditForm] = useState(false);
  const [deleteGoal, setDeleteGoal] = useState(false);
  const [formData, setFormData] = useState(null);
  const { isDropdownOpen } = useCustomizeDash();
  const dispatch = useDispatch();
  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.clientX); // Store the initial mouse position
    setScrollLeft(stgInnerHeaderRef.current.scrollLeft); // Store the initial scroll position
  };

  const handleMouseLeave = () => {
    setIsDragging(false); // Stop dragging when the mouse leaves
  };

  const handleMouseUp = () => {
    setIsDragging(false); // Stop dragging on mouse up
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    const distance = e.clientX - startX; // Calculate how much the mouse has moved
    stgInnerHeaderRef.current.scrollLeft = scrollLeft - distance; // Adjust scroll position based on mouse movement
  };

// ✅ Create a new goal
const handleCreateGoal = async (newGoal) => {
  try {
    setFormData(null)
    console.log('sss newGoal', newGoal, shortTermGoals)
    const newSubTask = {
      id: newGoal.id ? newGoal.id : Date.now(),
      stepId: newGoal.stepId ? newGoal.stepId : Date.now()+1,
      startdate: moment(newGoal.startDate).format("YYYY-MM-DD"),
      enddate: moment(newGoal.endDate).format("YYYY-MM-DD"),
      goal: newGoal.goal,
      status: "pending",
    };

    let updated = [...flattenedTasks];
    let updatedTimeline = [...timelineData];
    const goalIndices = updated.map(task => task.goalIndex).filter(index => index != null && !isNaN(index));
    const maxGoalIndex = goalIndices.length > 0 ? Math.max(...goalIndices) : 0;
    // const maxGoalIndex = Math.max(...updated.map(task => task.goalIndex));
    const existingGoalPos = updated.findIndex(goal => goal.id === newGoal.id);
    const existingStepPos = updated.findIndex(goal => goal.stepId === newGoal.stepId);
    const existingStepNamePos = updated.findIndex(goal => goal.goalTitle.toLowerCase() === newGoal.stepName.toLowerCase());
    
    console.log('sss updated', updated, newGoal.id, newGoal.stepId, existingGoalPos, existingStepPos, existingStepNamePos, maxGoalIndex, goalIndices)
    // return false;

    if(existingGoalPos !== -1){
      if(existingStepPos !== -1){
        let foundPhaseIndex = null;
        let oldPhaseName = null;
        let indexArr = [];
        updatedTimeline = updatedTimeline.map((item, index) => {
          if( item.phaseTitle.toLowerCase() === updated[existingGoalPos].goalTitle.toLowerCase() ){
            
            oldPhaseName = item.phaseTitle;
            
            if( moment(updated[existingGoalPos].startdate).isBetween(moment(item.startDate), moment(item.endDate), null, '[]') && moment(updated[existingGoalPos].enddate).isBetween(moment(item.startDate), moment(item.endDate), null, '[]') ){
              foundPhaseIndex = index;
              
              updated.map((item, indexSTG) => {

                if( oldPhaseName === item.goalTitle && ( moment(item.startdate).isBetween(moment(updatedTimeline[foundPhaseIndex].startDate), moment(updatedTimeline[foundPhaseIndex].endDate), null, '[]') && moment(item.enddate).isBetween(moment(updatedTimeline[foundPhaseIndex].startDate), moment(updatedTimeline[foundPhaseIndex].endDate), null, '[]') ) ){
                  indexArr.push(indexSTG)
                }
              })
            }
            
            return {
              ...item,
              phaseTitle: newGoal.stepName,
            }
          }
          return item;
        })
        // let indexArr = [];
        // updated.map((item, index) => {

        //   if( oldPhaseName === item.goalTitle && ( moment(item.startdate).isBetween(moment(updatedTimeline[foundPhaseIndex].startDate), moment(updatedTimeline[foundPhaseIndex].endDate), null, '[]') && moment(item.enddate).isBetween(moment(updatedTimeline[foundPhaseIndex].startDate), moment(updatedTimeline[foundPhaseIndex].endDate), null, '[]') ) ){
        //     indexArr.push(index)
        //   }
        // })
        
        if(existingStepNamePos !== -1){
          // change PhaseName with pre-existing name
          // console.log('sss updated existingStepNamePos if11', existingStepNamePos, updated[existingStepPos], updated[existingStepNamePos].id)
          updated = updated.map((item, index) => {
            
            if( existingGoalPos !== index && item.goalTitle.toLowerCase() === updated[existingGoalPos].goalTitle.toLowerCase() ){
              return {
                ...item,
                goalIndex: updated[existingStepNamePos].goalIndex,
                goalTitle: newGoal.stepName,
              }
            }
            return item
          })
          updated[existingGoalPos].goalTitle = newGoal.stepName;
          updated[existingGoalPos].goal = newSubTask.goal;
          updated[existingGoalPos].startdate = newSubTask.startdate;
          updated[existingGoalPos].enddate = newSubTask.enddate;
          updated[existingGoalPos].stepId = updated[existingStepNamePos].stepId;
          updated[existingGoalPos].goalIndex = updated[existingStepNamePos].goalIndex;
        }
        else{
          // change PhaseName with non-existing name
          // console.log('sss updated existingStepPos else21', existingStepPos, updated[existingStepPos], updated[existingStepPos].id)
          updated = updated.map((item, index) => {
            
            if( existingGoalPos !== index && item.goalTitle.toLowerCase() === updated[existingGoalPos].goalTitle.toLowerCase() ){
              return {
                ...item,
                goalIndex: maxGoalIndex+1,
                goalTitle: newGoal.stepName,
              }
            }
            return item
          })
          updated[existingGoalPos].goalIndex = maxGoalIndex+1;
          updated[existingGoalPos].goal = newSubTask.goal;
          updated[existingGoalPos].startdate = newSubTask.startdate;
          updated[existingGoalPos].enddate = newSubTask.enddate;
          updated[existingGoalPos].goalTitle = newGoal.stepName;
        }
        updatedTimeline = await adjustPhaseDatesAfterSubtaskEdit(updatedTimeline, foundPhaseIndex, updated, indexArr)
        console.log('sss updated change PhaseName with pre-existing name', updated, updatedTimeline)
        // return false;
      }
      else{
        // console.log('sss updated existingGoalPos else1', updated, existingGoalPos)
        updated[existingGoalPos] = {
          enddate: newSubTask.enddate,
          goal: newSubTask.goal,
          goalIndex: maxGoalIndex+1,
          goalTitle: newGoal.stepName,
          id: newSubTask.id,
          startdate: newSubTask.startdate,
          stepId: newSubTask.stepId,
          subTaskIndex: Date.now()+1,
        }
      }
    }
    else{
      let phaseExist = false;
      if(existingStepNamePos !== -1){
        console.log('sss updated existingStepNamePos if2', updated[existingStepNamePos].id, newSubTask, updated[existingStepNamePos])
        
        updatedTimeline = timelineData.map((item, index) => {
          
          if( newGoal.stepName.toLowerCase() === item.phaseTitle.toLowerCase() ){
            console.log('sss updated existingStepNamePos if2', item)
            
            if( moment(newGoal.startDate).isBetween(moment(item.startDate), moment(item.endDate)) && moment(newGoal.endDate).isBetween(moment(item.startDate), moment(item.endDate)) ){
              console.log('sss updated existingStepNamePos if2 1', item)
              phaseExist = true;
            }
            else if( moment(newGoal.startDate).isBetween(moment(item.startDate), moment(item.endDate)) || ( moment(newGoal.startDate).diff(moment(item.endDate), "days") >= 0 && moment(newGoal.startDate).diff(moment(item.endDate), "days") <= 1 ) ){
              console.log('sss updated existingStepNamePos if2 2', item)
              phaseExist = true;
              return { ...item, endDate: moment(newGoal.endDate).format("YYYY-MM-DD")}
            }
            else if( moment(newGoal.endDate).isBetween(moment(item.startDate), moment(item.endDate)) || ( moment(item.startDate).diff(moment(newGoal.endDate), "days") >= 0 && moment(item.startDate).diff(moment(newGoal.endDate), "days") <= 1 ) ){
              console.log('sss updated existingStepNamePos if2 3', item)
              phaseExist = true;
              return { ...item, startDate: moment(newGoal.startDate).format("YYYY-MM-DD")}
            }
            else{
              // phaseExist = false;

              phaseExist = true;
              return {
                ...item,
                startDate: item.startDate < moment(newGoal.startDate).format('YYYY-MM-DD') ? item.startDate : moment(newGoal.startDate).format('YYYY-MM-DD'),
                endDate: item.endDate > moment(newGoal.endDate).format('YYYY-MM-DD') ? item.endDate : moment(newGoal.endDate).format('YYYY-MM-DD')
              };
            }
          }
          return item
        })
        updatedTimeline = updatedTimeline.reduce((acc, current, index) => {
          // If this is the first item, just add it
          if (acc.length === 0) {
            acc.push(current);
            return acc;
          }
          
          const previous = acc[acc.length - 1];

          // Check if current item has same phaseTitle as previous
          if (current.phaseTitle.toLowerCase() === previous.phaseTitle.toLowerCase()) {

            // Calculate day difference between previous endDate and current startDate
            const dayDiff = moment(current.startDate).diff(moment(previous.endDate), "days");
            
            // If difference less than 1 day, merge them
            if (dayDiff <= 1) {
              console.log('sss item', dayDiff, current.startDate, previous.endDate)
              // Update the previous item's endDate to current item's endDate
              // Create a new object with updated endDate
              // previous.endDate = current.endDate;
              const updatedPrevious = {
                ...previous,
                endDate: current.endDate
              };
              // Replace the last item in accumulator
              acc[acc.length - 1] = updatedPrevious;
              phaseExist = true;
              return acc;
            }
          }

          // If no merge condition met, add current item
          acc.push(current);
          return acc;
        }, [])

        let uniqueID = moment().valueOf() // new unique ID
        if(!phaseExist){
          updatedTimeline.push({
            phaseId: uniqueID, 
            phaseTitle: newGoal.stepName,
            goalDescription: newGoal.goal,
            startDate: newGoal.startDate ? moment(newGoal.startDate).format("YYYY-MM-DD") : "",
            endDate: newGoal.endDate ? moment(newGoal.endDate).format("YYYY-MM-DD") : "",
          }); 
        }
        console.log('sss updated existingStepNamePos if2 4', updatedTimeline)
        // return false;  

        updated[updated.length] = {
          enddate: newSubTask.enddate,
          goal: newSubTask.goal,
          goalIndex: updated[existingStepNamePos].goalIndex,
          goalTitle: newGoal.stepName,
          id: newSubTask.id,
          startdate: newSubTask.startdate,
          status: "pending",
          stepId: updated[existingStepNamePos].stepId,
          subTaskIndex: Date.now()+1,
        }
      }
      else{
        updatedTimeline = [...timelineData, {
          phaseId: moment().valueOf(), 
          phaseTitle: newGoal.stepName,
          goalDescription: newGoal.goal,
          startDate: newGoal.startDate ? moment(newGoal.startDate).format("YYYY-MM-DD") : "",
          endDate: newGoal.endDate ? moment(newGoal.endDate).format("YYYY-MM-DD") : "",
        }]
        console.log('sss updated existingStepNamePos else2', updatedTimeline)
        // return false;
        updated[updated.length] = {
          enddate: newSubTask.enddate,
          goal: newSubTask.goal,
          goalIndex: maxGoalIndex+1,
          goalTitle: newGoal.stepName,
          id: newSubTask.id,
          startdate: newSubTask.startdate,
          status: "pending",
          stepId: newSubTask.stepId,
          subTaskIndex: 0,
        }
      }
    }
    console.log('sss updated 2', updated)
    let reconstructedGoals = [];
    updated.filter(phase => phase !== null && phase !== undefined).forEach(task => {
      const { goalIndex, subTaskIndex, goalTitle, ...rest } = task;
      // console.log('sss task', task)
      // Initialize the goal if it doesn't exist yet
      if (!reconstructedGoals[goalIndex]) {
        reconstructedGoals[goalIndex] = {
          id: goalIndex + 1,
          step: goalTitle,
          subTasks: [],
        };
      }
      
      // Assign the subtask at the correct index
      reconstructedGoals[goalIndex].subTasks.push(rest);
    })
    reconstructedGoals = reconstructedGoals.filter(phase => phase !== null)
    console.log("sss updated New reordered:", shortTermGoals, reconstructedGoals);
    // return false;
    // dispatch(setShortTermGoalsAsync(reconstructedGoals, userId))
    setTimeout(() => {
      dispatch(setTimelineAsync(updatedTimeline, userId))
    }, 100)
    setTimeout(() => {
      dispatch(setShortTermGoalsAsync(reconstructedGoals, userId))
    }, 200)
    message.success("Your work has been saved")
    setEditForm(false);
    setDeleteGoal(false);
  } catch (error) {
    console.error("Error creating goal:", error);
  }
};
// ✅ Delete a goal
const handleDeleteGoal = async (taskId, stepId) => {
  try {
    Modal.confirm({
      title: "Deleting this Short-Term Goal will also remove its corresponding Roadmap Phase.",
      content: "Proceed?",
      okText: "Yes",
      cancelText: "No",
      className: "custom-delete-stg-modal", 
      maskClosable: true,
      onOk: async () => {
        
        console.log("sss handleDeleteGoal Deleting subtask with id:", taskId, stepId);
    
        const updatedGoals = shortTermGoals
          .map((goal) => ({
            ...goal,
            subTasks: goal.subTasks.filter((task) => task.id !== taskId && task.stepId !== stepId),
          }))
          .filter((goal) => goal.subTasks.length > 0);
    
        const updatedTimelineData = await adjustPhaseDatesAfterSubtaskDeletion(shortTermGoals, timelineData, taskId)
        console.log('sss handleDeleteGoal', updatedTimelineData, timelineData);
        // return false
    
        setTimeout(() => {
          dispatch(deleteShortTermGoalsAsync(taskId, stepId, userId))
          // dispatch(setShortTermGoalsAsync(updatedGoals, userId))
        }, 100)
        setTimeout(() => {
          dispatch(setTimelineAsync(updatedTimelineData, userId))
        }, 200)
        message.success("Your work has been saved")
      }
    });
    setTimeout(() => {
      const modalElements = document.querySelectorAll(".ant-modal");
      const latestModal = modalElements[modalElements.length - 1];
      if (latestModal) latestModal.setAttribute("data-modal-id", "custom-delete-stg-modal");
      const btnElement = document.querySelector('.ant-modal[data-modal-id="custom-delete-stg-modal"] .ant-btn:not(ant-btn-primary)');
      btnElement.setAttribute("type", "primary");
      btnElement.classList.add('button-secondary')
      btnElement.classList.remove('ant-btn')

      const btnElement2 = document.querySelector('.ant-modal[data-modal-id="custom-delete-stg-modal"] .ant-btn.ant-btn-primary');
      btnElement2.setAttribute("type", "primary");
      btnElement2.classList.add('button-main')
      btnElement2.classList.remove('ant-btn')
      btnElement2.classList.remove('ant-btn-primary')
    }, 0);

  } catch (error) {
    console.error("sss handleDeleteGoal Error deleting subtask:", error);
  }
};

const handleDelete = () => {
  // console.log('sss left', left)
  // left ? setLeftSections((prev) => prev.filter((section) => section.id !== compID)) : setRightSections((prev) => prev.filter((section) => section.id !== compID));
  try {
    const payload = { "step_id": compID, "user_id": userId }
    console.log("sss delete", payload);
    DASHBOARD_API.deleteDashboardItem(payload)
    .then((response) => {
      console.log("sss delete api response", response);
      message.success("Your work has been saved")
      setTmpState(!tmpState)
    })
    .catch((err) => {
      console.log("sss delete api error", err, payload);
      message.error("Your work has not been saved")
    });
  } catch (error) {
    console.error("Error deleting item:", error);
  }
};


  // ✅ Save all goals
  const handleSaveGoals = async () => {
    try {
      setFormData(null)
      dispatch(setShortTermGoalsAsync(shortTermGoals, userId))
      message.success("Your work has been saved")
      setToggling(false);
    } catch (error) {
      console.error("Error saving goals:", error);
    }
  };

  const sortableRef = useRef(null);
  useEffect(() => {
    if (toggling && sortableRef.current) {
      const sortable = new Sortable(sortableRef.current, {
        animation: 150,
        handle: ".stg-subtask-card", // optional
        group: { name: "shared_shortTermGoals", pull: false, put: false },
        swapThreshold: 0.65,
        onStart: (evt) => {
          evt.item.__originalParent = evt.from || null; // Store original parent
        },
        onUpdate: (evt) => {
          const { oldIndex, newIndex } = evt;
          if (oldIndex !== newIndex) {
            const updated = [...flattenedTasks];
            const [moved] = updated.splice(oldIndex, 1);
            updated.splice(newIndex, 0, moved);

            // Update only the moved task's startdate based on neighbors
            const prev = updated[newIndex - 1] || null;
            const next = updated[newIndex + 1] || null;
            console.log('sss prev', prev, next)

            // if (prev) {
            //   updated[newIndex].startdate = prev.startdate;
            //   updated[newIndex].enddate = prev.enddate;
            // } else if (next) {
            //   updated[newIndex].startdate = next.startdate;
            //   updated[newIndex].enddate = next.enddate;
            // } else {
            //   updated[newIndex].startdate = prev.startdate;
            //   updated[newIndex].enddate = prev.startdate;
            // }
            // // Here, rebuild `shortTermGoals` based on reordered `updated`
            // console.log("sss New reordered list:", updated, prev, next, moved, oldIndex, newIndex);

            const reconstructedGoals = [];
            updated.forEach(task => {
              const { goalIndex, subTaskIndex, goalTitle, ...rest } = task;
              console.log('sss task', task)
              // Initialize the goal if it doesn't exist yet
              if (!reconstructedGoals[goalIndex]) {
                reconstructedGoals[goalIndex] = {
                  id: goalIndex + 1,
                  step: goalTitle,
                  subTasks: [],
                };
              }
              
              // Assign the subtask at the correct index
              reconstructedGoals[goalIndex].subTasks.push(rest);
            })
            // console.log("sss New reordered list:", shortTermGoals, reconstructedGoals);
            // Then update via dispatch
            dispatch(setShortTermGoalsAsync(reconstructedGoals, userId))
            message.success("Your work has been saved")
          }
          else{
            console.log('sss evt 1', evt)
          }
        },
      });
  
      return () => sortable.destroy();
    }
    else{
      // console.log('sss New else', flattenedTasks)
    }
  }, [toggling, flattenedTasks]);

  const handleDragStart = (e, item) => {
    e.stopPropagation(); // Prevent event bubbling
    e.dataTransfer.setData("text/plain", JSON.stringify(item));
    e.dataTransfer.effectAllowed = "move";
  };

  const handleGoalMouseDown = (e) => {
    e.stopPropagation(); // Prevent unwanted drag behavior
  };

  const capitalizeEachWord = (sentence) => {
    return sentence
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  const renderGoalBands = (result) => {
    let accumulatedWidth = 0;
    let num = 0.1
    let lgr = 9
    let lgg = 188
    let lgb = 201
    
    return result.map(function(task, gIndex) {
      const leftPos = accumulatedWidth;
      const width = task.count * SUBTASK_WIDTH;
      
      accumulatedWidth += width;

      if(task.stepId) {
        num = Math.round( (num < 0.9 ? num + 0.05 : num) * 10) / 10
        // num = 0.2
        lgr = lgr > 1 ? lgr - 1 : lgr
        // lgg -= 8
        // lgb -= 8
        lgg = lgg > 69 ? lgg - 8 : lgg - 4
        lgb = lgb > 81 ? lgb - 8 : lgb - 4
      }
      // background: linear-gradient(90deg, rgba(7, 150, 161, 0.2) 0%, rgba(255, 255, 255, 0.2) 183.46%);
      // background: linear-gradient(90deg, rgba(6, 131, 141, 0.2) 0%, rgba(255, 255, 255, 0.2) 183.46%);


      console.log('background gIndex: ', gIndex, lgr, lgg, lgb, num)

      const background = `linear-gradient(90deg, rgba(${lgr}, ${lgg}, ${lgb}, ${num}) 0%, rgba(255, 255, 255, 0.2) 183.46%)`;
      return (
        <div
          key={gIndex}
          className="stg-goal-band"
          style={{
            left: leftPos,
            width: width,
          }}
        >
          <div className="stg-goal-title" gIndex={gIndex} title={(task.goalTitle)} style={{ width: width, background: background }}
            // onClick={() => console.log('sss goalTitle', task)}
          >
            {/* {capitalizeEachWord(task.goalTitle)} */}
            {(task.goalTitle)}
          </div>
        </div>
      );
    });
  }
  
  return (
    <Card
      bordered={false}
      style={toggling
        ? {
        boxShadow: "0px 3px 16px 0px #1313131A",
        borderRadius: "12px",
        textAlign: "left",
        margin: "0px 20px",
        height: "fit-content",
        border: "2px dashed #4CA8AC",
        backgroundColor: "#F6FAFB",
      } : {
        boxShadow: "0px 3px 16px 0px #1313131A",
        borderRadius: "12px",
        textAlign: "left",
        margin: "0px 20px",
        height: "fit-content",
      }}
    >
      <div className="stg-header">
        <div className="stg-left-header">
          <img
            src="https://django-woken-static.s3.us-east-2.amazonaws.com/static/media/dashboardMyTasksDrag.svg"
            className="stg-icon"
            alt="drag icon"
          />
          <span className="my-career-roadmap-title">Short-term Goals</span>
        </div>

          { isDropdownOpen ? (
              <img
                src="https://django-woken-static.s3.amazonaws.com/static/media/compRemove.svg"
                alt="delete icon"
                className="delete-icon"
                style={{
                  cursor: "pointer",
                }}
                onClick={handleDelete}
              />
           ) : !toggling ? (
            <div
              style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: "8px",
              }}>
              {
                blankSTG &&
                <button
                  type="primary"
                  size="large"
                  className="button-main my-career-roadmap-add-new-phase-button"
                  onClick={(event) => {
                    event.stopPropagation();
                    setEditForm(true);
                    setDeleteGoal(false);
                  }}
                  ><PlusOutlined />Add New Goal</button>
              }
              <img
                src="https://django-woken-static.s3.amazonaws.com/static/media/editbtn.svg"
                alt="edit"
                style={{ cursor: "pointer" }}
                onClick={()=>{setToggling(true)}}
                />
            </div>
            ) : (
              <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    gap: "8px",
                }}>
                <img
                  src="https://django-woken-static.s3.amazonaws.com/static/media/plusbtn.svg"
                  alt="add"
                  style={{ cursor: "pointer" }}
                  onClick={()=>{
                    // console.log('sss editForm 1: ', editForm)
                    setEditForm(true);
                    setDeleteGoal(false);
                  }}
                />
              </div>
          )}
        {/* </button> */}
      </div>
      
        {!toggling ? (
          <div
          className="stg-inner-header"
          ref={stgInnerHeaderRef}
          // onMouseDown={handleMouseDown}
          // onMouseLeave={handleMouseLeave}
          // onMouseUp={handleMouseUp}
          // onMouseMove={handleMouseMove}
        >
          <div className="stg-inner">
            {/* Render a thin line (goal band) for each goal with the title centered */}

            {
              renderGoalBands(result)
            }

            {/* Render each sub-task as a dot plus its connector line */}
            {flattenedTasks.map((task, index) => {
              const { startdate, enddate, goal, status, goalIndex } = task;
              const nextTask = flattenedTasks[index + 1];
              const leftPos = index * SUBTASK_WIDTH;

              const text = goal;
              const font = "15px AvenirBook";
              const maxWidth = 386;

              const textWidth = getTextWidth(text, font);
              console.log('sss getTextWidth', textWidth)
              // const resultText = textWidth > maxWidth ? truncateToWidth(text, maxWidth, font) : text;
              const resultText = wrapTextToWidth(text, maxWidth, font).length > 1 ? `${wrapTextToWidth(text, maxWidth, font)[0]}...` : wrapTextToWidth(text, maxWidth, font)[0];

              return (
                <div
                  key={index}
                  className="stg-step-wrapper"
                  style={{ left: leftPos }}
                >
                  {/* Dot */}
                  <div className="stg-dot" />
                  {/* Date and title below the dot */}
                  <div className="stg-subtask-info"
                    // onClick={() => {
                    //   setEditForm(true)
                    //   setDeleteGoal(true);
                    //   setFormData(task);
                    // }}
                  >
                    <p className="stg-date">{moment(startdate).format("MMM D, YYYY")} - </p>
                    <p className="stg-date">{moment(enddate).format("MMM D, YYYY")}</p>
                    {/* <p className="stg-subtask-title">{goal.length > 28 ? `${capitalizeEachWord(goal).slice(0, 28)}...` : capitalizeEachWord(goal)}</p> */}
                    {/* <p className="stg-subtask-title">{goal.length > 28 ? `${(goal).slice(0, 28)}...` : (goal)}</p> */}
                    {/* <p className="stg-subtask-title">{goal.length > 28 ? `${(goal).slice(0, 32)}...` : (goal)}</p> */}
                    <p className="stg-subtask-title">{(resultText)}</p>
                  </div>
                  {/* Connector line to next sub-task (if within the same goal) */}
                  {/* {nextTask && nextTask.goalIndex === goalIndex && ( */}
                    <div
                      className={`stg-connector ${getGoalStatus(moment(startdate), moment(enddate))}`}
                      style={{
                        // borderTop: getLineStyle(status)
                        borderTop: getLineStyle(getGoalStatus(moment(startdate), moment(enddate))),
                      }}
                    />
                  {/* )} */}
                </div>
              );
            })}
          </div>
          </div>
        ) : (
          <div className="stg-edit-container">
          <div className="stg-inner-edit" ref={stgInnerHeaderRef}
          // onMouseDown={handleMouseDown}
          // onMouseLeave={handleMouseLeave}
          // onMouseUp={handleMouseUp}
          // onMouseMove={handleMouseMove}
          >
            {/* <div className="card-wrapper" ref={sortableRef}> */}
            <div className="card-wrapper">
            {flattenedTasks.map((task, index) => {
                const { startdate, enddate, goal, status, goalIndex } = task;
                const nextTask = flattenedTasks[index + 1];
                const leftPos = index * SUBTASK_WIDTH;

                const text = goal;
                const font = "15px AvenirBook";
                const maxWidth = 386;

                const textWidth = getTextWidth(text, font);
                console.log('sss getTextWidth', textWidth)
                // const resultText = textWidth > maxWidth ? truncateToWidth(text, maxWidth, font) : text;
                const resultText = wrapTextToWidth(text, maxWidth, font).length > 1 ? `${wrapTextToWidth(text, maxWidth, font)[0]}...` : wrapTextToWidth(text, maxWidth, font)[0];

                return (
                  
                  // <div className="stg-subtask-card" draggable="true" onMouseDown={handleGoalMouseDown} onDragStart={(e) => handleDragStart(e, task)}>
                  <div className="stg-subtask-card" onMouseDown={handleGoalMouseDown} onDragStart={(e) => handleDragStart(e, task)}>
                    <p className="stg-date" onClick={() => {
                      setEditForm(true)
                      setDeleteGoal(false);
                      setFormData(task);
                    }}>{moment(startdate).format("MMM D, YYYY")} - </p>
                    <p className="stg-date" onClick={() => {
                      setEditForm(true)
                      setDeleteGoal(false);
                      setFormData(task);
                    }}>{moment(enddate).format("MMM D, YYYY")}</p>
                    <p className="stg-subtask-title" onClick={() => {
                      setEditForm(true)
                      setDeleteGoal(false);
                      setFormData(task);
                    }}>
                      {/* {goal.length > 28 ? `${capitalizeEachWord(goal).slice(0, 28)}...` : capitalizeEachWord(goal)} */}
                      {/* {(goal)} */}
                      {resultText}
                      </p>
                      <img className="remove-task" onClick={() => handleDeleteGoal(task.id, task.stepId)} src="https://django-woken-static.s3.amazonaws.com/static/media/crossbtn.svg" alt="crossbtn"/>
                  </div>
                  
                );
              })}
              </div>
          
          </div>
          <div style={{display: "flex", justifyContent: "flex-end", columnGap: "15px", marginTop: "5px"}}>
          <button
            onClick={() => {
              setToggling(false);
              setFormData(null)
            }}
          className="button-secondary" style={{ width: "10%", minWidth: "max-content" }}
          >
            Cancel
          </button>
          <button className="button-main" style={{ width: "10%", minWidth: "max-content" }} onClick={handleSaveGoals}>Save</button>
          </div>
          </div>
        )}
      
      {editForm &&
        ReactDOM.createPortal(
          <CreateShortTermGoals
            formData={formData}
            onSave={handleCreateGoal}
            onDelete={handleDeleteGoal}
            deleteGoal={deleteGoal}
            onCancel={() => {
              setEditForm(false)
              setDeleteGoal(false);
              setFormData(null)
            }} />,
          document.body
        )}
    </Card>
  );
}
